<template>
    <div class="tiandimap">
        <div class="searchWrap">
            <div class="search"><input ref="input" class="text"/><div class="btn" @click="searchFn">搜索</div></div>
            <div class="result" v-if="showRes">
                <div class="item" v-for="el in dataList" :key="el.hotPointID" @click="toLocal(el)">
                    <span class="name">{{el.name}}</span>
                    <span class="addr">{{el.address}}</span>
                </div>
            </div>
        </div>
        <div class="map" id="mapDiv" style="position:absolute;width:100vw; height:100vh"></div>
    </div>
</template>
  
<script>
  export default {
    name: 'TiandiMap',
    data() {
        return {
            map: null,
            showRes: false,
            dataList: []
        };
    },
    computed: {},
    mounted() {
        this.initMap();
    },
    methods: {
        initMap() {
            this.map = new T.Map('mapDiv');
            const lnglat = new T.LngLat(116.40969,39.89945);
            this.map.centerAndZoom(lnglat, 12);
            this.getGeoLocation();
        },
        getGeoLocation() {
            const lo = new T.Geolocation();
            const fn = function (e) {
                if (this.getStatus() == 0){
                    this.map.centerAndZoom(e.lnglat, 15)
                    const marker = new T.Marker(e.lnglat);
                    this.map.addOverLay(marker);

                }
                if(this.getStatus() == 1){
                    this.map.centerAndZoom(e.lnglat, e.level)
                    const marker = new T.Marker(e.lnglat);
                    this.map.addOverLay(marker);
                }
            }
            lo.getCurrentPosition(fn);
        },
        searchFn () {
            const localSearchResult = (result) => {
                this.showRes = true;
                this.dataList = result.pois;
            }
            const config = {
                pageCapacity: 100, //每页显示的数量，最大100条
                onSearchComplete: localSearchResult	//接收数据的回调函数
            };
            //创建搜索对象
            const localsearch = new T.LocalSearch(this.map, config);
            localsearch.search(this.$refs.input.value);
        },
        toLocal(e) {
            this.showRes = false;
            const lnglat = e.lonlat?.split(',');
            const marker = new T.Marker(new T.LngLat(Number(lnglat[0]), Number(lnglat[1])));
            this.map.addOverLay(marker);
            this.map.panTo(new T.LngLat(Number(lnglat[0]), Number(lnglat[1])));
            const markerInfoWin = new T.InfoWindow(`地址：${e.address}`);
            marker.addEventListener("click", function () {
                marker.openInfoWindow(markerInfoWin);
            });
        }
    }
  }
</script>
  
<style scoped>
.tiandimap {
    position: relative;
}
.searchWrap{
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 2;
    .search {
        display: flex;
        align-items: center;
        .text {
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
            border: none;
            height: 30px;
            width: 300px;
            padding: 0 10px;
            color: #606266;
            border: 1px solid rgba(0, 0, 0, 0.15);
            font-size: 14px;
        }
        .btn {
            background-color: #0e71ff;
            height: 32px;
            line-height: 32px;
            color: #fff;
            font-size: 16px;
            padding: 0 12px;
            cursor: pointer;
            border-top-right-radius: 2px;
            border-bottom-right-radius: 2px;
        }
    }
    .result {
        width: 320px;
        border-radius: 2px;
        background-color: #fff;
        max-height: 24vw;
        overflow-y: scroll;
        .item {
            text-align: left;
            padding: 8px 10px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            cursor: pointer;
            .name {
                font-size: 14px;
                font-weight: 400;
                color: #000;
            }
            .addr {
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                margin-left: 10px;
            }
        }
    }
}
.map {
    z-index: 1;
}
</style>
  